import { useRecordContext } from 'react-admin';
import { formatToUtc } from '../../utils/dateUtils';

export const DateInOneRow = ({ source, ...props }) => {
  const record = useRecordContext();
  const dateValue = record?.[source];

  return dateValue ? <span>{formatToUtc(dateValue)}</span> : null;
};
